var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mj-drop-down-up-transition',[(_vm.isOpen)?_c('div',{staticClass:"mt-2 absolute",class:(_vm.direction + "-0 origin-top-" + _vm.direction)},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }